<Slide :i :slide :current_slide>
    <div class="media-outer">
        <video ref:video loop>
            {{#if slide.webm }}<source src="{{ video(slide.webm) }}" type="video/webm">{{/if}}
            {{#if slide.mp4 }}<source src="{{ video(slide.mp4) }}" type="video/mp4">{{/if}}
        </video>
    </div>
</Slide>

<script>
import Slide from './GallerySlide.html'
import { video, noop } from '../../helpers'

export default {

    components: {
        Slide,
    },

    data() {
        return {
            i: 0,
            slide: {},
        }
    },

    oncreate () {
        this.observers = [];

        const { video } = this.refs;

        this.observers.push(this.store.observe('muted', muted => {
            video.muted = muted;
        }, { defer: true }));

        this.observe('current_slide', current => {
            if (current == this.get('i')) {
                this.play();
            } else {
                this.pause();
            }
        });

    },

    ondestroy() {
        for (let i = this.observers.length - 1; i >= 0; i--) {
            this.observers[i].cancel();
        }
    },

    methods: {
        play() {
            this.refs.video.play().catch(noop);
        },

        pause() {
            this.refs.video.pause();
        },
    },

    helpers: {
        video,
    }
}
</script>